import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { verification } from "../../services/apiService";
import {  showToast } from '../Toast/CommonToast';
import Loader from "../Loader/loader";

const Verification = () => {
    const { verificationId } = useParams();
    const navigate = useNavigate();
    const [ loading , setLoading ] = useState(true);

    useEffect(() => {
        const verify = async () => {
            try {
                const payload = {
                    verificationId: verificationId
                }
                const response = await verification(payload);
                if(response.status === "true") {
                        localStorage.setItem("accessToken", response?.data?.token);
                        localStorage.setItem("refreshToken", response?.data?.refreshToken);
                        localStorage.setItem("name", response?.data?.name);
                        localStorage.setItem("userId", response?.data?._id);
                        localStorage.setItem('email', response?.data?.email);
                        localStorage.setItem("isVerified", response?.data?.isVerified);
                        setTimeout(()=>{
                            navigate("/home");
                        setLoading(false);
                        showToast(`${response.message}` || "User verified", "success");
                        },1000)

                    } else {
                        console.log(response)
                        showToast(`${response.message}` || "Please login", "success");
                        localStorage.clear();
                        navigate("/login");
                        setLoading(false);

                    }
                    
             
                    // localStorage.setItem("isVerified", response?.user?.isVerified);
                console.log(response);
            } catch (error) {
                console.log(error);
                setLoading(false);
                showToast("Error in validation", "error");
                navigate("/login");
            }
        }
        verify();
    }, [verificationId, navigate]);

    return (
       <Loader open={loading}/>
        );
}

export default Verification;